
import { useState } from 'react';

interface Track {
  id: number;
  title: string;
  explicit: boolean;
}

export default function Music() {
  const [hoveredTrack, setHoveredTrack] = useState<number | null>(null);

  const tracks: Track[] = [
    { id: 1, title: 'BAD GUY', explicit: true },
    { id: 2, title: 'TOO REAL', explicit: false },
    { id: 3, title: 'ANYWHERE', explicit: true },
    { id: 4, title: 'NOTTHISONE', explicit: false },
    { id: 5, title: 'LOUDER', explicit: true },
    { id: 6, title: 'IMPATIENT', explicit: true },
    { id: 7, title: 'CALLMEUP', explicit: false },
    { id: 8, title: 'SAYWHATYOUWANT', explicit: false },
    { id: 9, title: 'LOVE NO MORE', explicit: false },
    { id: 10, title: 'I JUST DIDN\u2019T STOP', explicit: false },
    { id: 11, title: 'JOE GOLDBERG', explicit: true },
    { id: 12, title: 'FED UP', explicit: false },
    { id: 13, title: 'FEEL GOOD', explicit: true },
    { id: 14, title: 'THROWBACK (FREAK ME)', explicit: true },
    { id: 15, title: 'EVERY TIME', explicit: false },
    { id: 16, title: 'YOU STILL', explicit: true },
    { id: 17, title: 'REARVIEW', explicit: false },
    { id: 18, title: 'VITAMINA E', explicit: false },
    { id: 19, title: 'I STILL', explicit: false },
  ];

  return (
    <section id="music" className="py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black mb-4 text-white">
            THE NEW ALBUM
          </h2>
          <p className="text-xl text-gray-400">
            REARVIEW — Streaming on all platforms now
          </p>
          <p className="text-sm text-red-500 mt-3 font-semibold">
            19 TRACKS
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-start">
          {/* Album Cover */}
          <div className="relative group sticky top-8">
            <div className="absolute inset-0 bg-red-600/30 blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <img
              src="https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/0fe0eea69dfb0ed5f21125c592cefc4e.png"
              alt="REARVIEW Album Cover"
              className="relative w-full h-auto object-cover object-top shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent p-8">
              <h3 className="text-3xl font-black text-white mb-2">REARVIEW</h3>
              <p className="text-red-500 font-semibold">E.T.C — 2025</p>
            </div>
          </div>

          {/* Track List */}
          <div className="space-y-2">
            {tracks.map((track) => (
              <div
                key={track.id}
                onMouseEnter={() => setHoveredTrack(track.id)}
                onMouseLeave={() => setHoveredTrack(null)}
                className={`p-4 border-2 transition-all duration-300 ${
                  hoveredTrack === track.id
                    ? 'bg-zinc-900 border-red-600/50'
                    : 'bg-zinc-900/50 border-zinc-800'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 flex-1">
                    <span className="text-lg font-black text-red-500 w-8 text-right">
                      {track.id.toString().padStart(2, '0')}
                    </span>
                    <div className="flex items-center gap-3">
                      <h4 className="text-base font-bold text-white">{track.title}</h4>
                      {track.explicit && (
                        <span className="px-1.5 py-0.5 bg-white/10 text-[10px] font-bold text-gray-400 tracking-wider leading-none">
                          E
                        </span>
                      )}
                    </div>
                  </div>
                  <i className={`ri-music-2-line text-lg transition-colors duration-300 w-6 h-6 flex items-center justify-center ${
                    hoveredTrack === track.id ? 'text-red-500' : 'text-zinc-600'
                  }`}></i>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Genre Tags */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 mb-4 uppercase tracking-wider text-sm">Sonic Influences</p>
          <div className="flex flex-wrap justify-center gap-4">
            <span className="px-6 py-3 bg-zinc-900 border border-zinc-700 text-white font-semibold">Kanye\u2019s Innovation</span>
            <span className="px-6 py-3 bg-zinc-900 border border-zinc-700 text-white font-semibold">Rocky\u2019s Mystique</span>
            <span className="px-6 py-3 bg-zinc-900 border border-zinc-700 text-white font-semibold">Virgil\u2019s Vision</span>
            <span className="px-6 py-3 bg-zinc-900 border border-zinc-700 text-white font-semibold">Billie\u2019s Intimacy</span>
          </div>
        </div>
      </div>
    </section>
  );
}
